import { Corn } from '@eigtech/shared-corn'
import { makeBasicQueryKeys } from '@eigtech/ui-shared-api'
import { pick } from 'lodash-es'

export const assignmentsBasePath = 'assignments'

const { all } = makeBasicQueryKeys('assignments')
const assignable = pick(makeBasicQueryKeys([...all(), 'assignable']), ['all'])
const assignee = pick(makeBasicQueryKeys([...all(), 'assignee']), ['all'])

export const assignmentsQueryKeys = {
  all,
  assignable: {
    ...assignable,
    entity: (corn: Corn) => [...assignmentsQueryKeys.assignable.all(), corn],
    assignments: (corn: Corn) => [...assignmentsQueryKeys.assignable.entity(corn), 'assignments'],
  },
  assignee: {
    ...assignee,
    entity: (corn: Corn) => [...assignmentsQueryKeys.assignee.all(), corn],
    assignments: (corn: Corn) => [...assignmentsQueryKeys.assignee.entity(corn), 'assignments'],
    assignables: (corn: Corn) => [...assignmentsQueryKeys.assignee.entity(corn), 'assignables'],
  },
}
